import React from 'react';
import styled from 'styled-components';

import SelectionBox from '../components/UI/SelectionBox/SelectionBox';
import DateSelector from '../components/UI/DateSelector/DateSelector';

import TimePicker from '../components/UI/TimePicker/TimePicker';
import ProgreesNotification from '../components/UI/ProgreesNotification/ProgreesNotification';
import ConsoleLog from './../hoc/ConsoleLog/ConsoleLog';

const ComponentListStyle = styled.div`
  background-color: #FFFFFF;
  height: auto;
  margin: 20px 10px;
  margin-top:50px;
  font-size: 18px;
  font-weight: 500;
  display: grid;
  grid-template: repeat(1, auto) / repeat(1, 100%);
  @media(min-width: 800px) {
    margin: 30px;
    margin-top:50px;
    display: grid;
    grid-template: repeat(2, auto) / repeat(2, 50%);
  }

  &>.component-code {
    padding: 20px;
    font-size: 14px;
    border: solid 1px #e9eff4;
    border-radius: 4px;
    background-color: #f4f8f9;
    margin-top: 30px;

    &> span {      
      display: block;
      margin-bottom: 10px; 
      line-height: 1.5rem;
    } 
    
    &>.usage-title {
      font-size: 16px;
      font-weight: 500;
    }

    & .code-snippet > span {      
      display: block;
      margin-bottom: 10px; 
      line-height: 1.5rem;
    }

    &>table {
      width: 100%;
      margin-top: 10px;
    }

    &> table,th,td {
      border: solid 1px;
      padding: 10px;
    }  

    @media(min-width: 800px) {
      margin-top: 0;
    }
  }  
`;

const ComponentList = () => {
  const data = [{ id: 1, label: "30 mins" },
  { id: 2, label: "1 hr" },
  { id: 3, label: "1.5 hr" },
  { id: 4, label: "2 hr" },
  { id: 5, label: "2.5 hr" },
  { id: 6, label: "3 hr" }];
  return (
    <React.Fragment>
      <ComponentListStyle >
        <div>
          Selection Box
          <SelectionBox
            data={data}
            handleSelect={(e) => ConsoleLog('handle select', e)}
          />
        </div>
        <div className="component-code">
          {`<SelectionBox 
            data={data}
            handleSelect={(e) => ConsoleLog('handle select', e)}
          />`}
        </div>
      </ComponentListStyle>
      <ComponentListStyle >
        <div>
          Date Selector
          <DateSelector format="dd/mm/yyyy" date={new Date('2019-03-31')} handleSelect={() => { }} />
        </div>
        <div className="component-code">
          <span className="usage-title">Usage</span>
          <div className="code-snippet">
            <span className="import-component">import DateSelector from '../components/UI/DateSelector/DateSelector';</span>
            <span className="component-tag">{`<DateSelector format="dd/mm/yyyy" handleSelect={this.handleSelect} />`}</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Prop name</th>
                <th>Description</th>
                <th>Example values</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>date</td>
                <td>Date to be shown in DateSelector</td>
                <td>
                  <ul>
                    <li>Default value: null</li>
                    <li>Type: object</li>
                    <li>Eg: new Date()</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>format</td>
                <td>Date format to be shown in DateSelector</td>
                <td>
                  <ul>
                    <li>Default value: 'dd mmm yyyy'</li>
                    <li>Type: string</li>
                    <li>supported formats: 'dd/mm/yyyy', 'mm/dd/yyyy', 'dd mmm yyyy'</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>handleSelect</td>
                <td>function reference to date select handler function</td>
                <td>
                  <ul>
                    <li>Type: function</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ComponentListStyle>
      <ComponentListStyle >
        <div>
          Time Picker
          <TimePicker selectedTime={14} />
        </div>
        <div className="component-code">
          <span className="usage-title">Usage</span>
          <div className="code-snippet">
            <span className="import-component">import DateSelector from '../components/UI/DateSelector/DateSelector';</span>
            <span className="component-tag">{`<DateSelector format="dd/mm/yyyy" handleSelect={this.handleSelect} />`}</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>Prop name</th>
                <th>Description</th>
                <th>Example values</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {/* <td>date</td>
                <td>Date to be shown in DateSelector</td>
                <td>
                  <ul>
                    <li>Default value: null</li>
                    <li>Type: object</li>
                    <li>Eg: new Date()</li>
                  </ul>
                </td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </ComponentListStyle>
        <div>
        Progrees Notification
          <ProgreesNotification
            className={" pg-ProgreesNotification"}
          />
        </div>
    </React.Fragment>
  )
}

export default ComponentList;


// WEBPACK FOOTER //
// ./src/container/ComponentList.js